import React from 'react';
import { connect } from 'react-redux';

import Login from './components/Login';
import Menu from './components/Menu';
import Body from './components/Body';
import ErrorBoundary from './components/ErrorBoundary';
import GlobalSpinner from './components/GlobalSpinner';

import { ThemeProvider } from '@mui/material/styles';
import { MUICustomTheme, RootContainer, RootInnerContainer, Snackbar, Alert, AlertTitle } from './AppStyles';

import { loginUser } from './actions/loginUser';
import { updateError, updateErrorMessage, updateSuccessMessage, updateMessage, resetState } from './actions/commonActions';

class App extends React.Component {
	constructor(props) {
		super(props);
		props.resetState();

		this.state = {
		};
	}

	componentDidMount() {
	}

	componentDidUpdate() {
	}

	handleSnackBarClose = (e, reason) => {
		this.props.updateError(false);
		this.props.updateErrorMessage(false);
		this.props.updateSuccessMessage(false);
		this.props.updateMessage(false);
	};

	handleConnectivityError = (flag, message = null) => {
		this.props.updateError(flag, message);
	};

	render() {
		window.addEventListener('online', () => this.handleConnectivityError(false));
		window.addEventListener('offline', () => this.handleConnectivityError(true, 'You are not connected to Internet'));

		let { login, reason, messageType, messageState, messageText, errorShow } = this.props;

		return (
			<ThemeProvider theme={MUICustomTheme}>
				<ErrorBoundary>
					<Snackbar
						style={{ marginTop: '4rem' }}
						open={errorShow || messageState}
						anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
						autoHideDuration={3000}
						onClose={(e) => {
							this.handleSnackBarClose(e);
						}}
					>
						<Alert
							style={{ boxShadow: '0 0 20px 10px lightgrey' }}
							onClose={(e) => {
								this.handleSnackBarClose(e, 'close clicked');
							}}
							severity={errorShow ? 'error' : messageType}
						>
							<AlertTitle>Message</AlertTitle>
							{JSON.stringify(messageText ? messageText : reason)}
						</Alert>
					</Snackbar>

					<GlobalSpinner />

					<RootContainer>
						<RootInnerContainer>
							{login ? (
								<>
									<Login />
								</>
							) : (
								<>
									<Menu />
									<Body />
								</>
							)}
						</RootInnerContainer>
					</RootContainer>
				</ErrorBoundary>
			</ThemeProvider>
		);
	}
}

const mapStatesToProps = (state) => {
	return {
		login: state.session.login,
		errorShow: state.error.errorState,
		reason: state.error.reason,
		messageType: state.message.type,
		messageState: state.message.message,
		messageText: state.message.text,
	};
};

export default connect(mapStatesToProps, { loginUser, resetState, updateError, updateErrorMessage, updateSuccessMessage, updateMessage })(App);
